module.exports = __webpack_public_path__ + "img/001.d083bded.png";